import styled from 'styled-components'

import {
  COLORS,
  CSS_ELEMENTS_RESETS,
  hoverSelector,
  typeScale,
} from '../../styles'
import Icon from '../Icon'

const Styled = styled.div`
  ${CSS_ELEMENTS_RESETS.button};
  display: inline-flex;
  padding: 0.4rem 0.8rem;
  align-items: center;
  cursor: ${({ isLoading }) => (isLoading ? 'default' : 'pointer')};

  & * {
    transition: fill 0.2s ease-in-out;
  }
  ${({ isLoading }) =>
    isLoading
      ? ''
      : hoverSelector('*')`
    fill: ${COLORS.primary};
  `}
`
Styled.heart = styled(Icon)`
  display: block;
  width: 2.4rem;
  height: 2.4rem;
`
Styled.count = styled.span`
  ${typeScale('body')};
  display: inline-block;
  position: relative;
  margin-left: 0.4rem;
`

export default Styled
